export default __webpack_public_path__ + "static/Aime-ThinItalic-97a2faec9607d9cfb657b3d91ce0540f.woff2";